import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-elearning',
  templateUrl: './elearning.component.html',
  styleUrls: ['./elearning.component.css']
})
export class ElearningComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }


  onChildData(event: any) {
    this.router.navigate([event]);
  }

}
